import { render, staticRenderFns } from "./MenuSideBarSection.vue?vue&type=template&id=37180f1a&scoped=true"
import script from "./MenuSideBarSection.vue?vue&type=script&lang=ts"
export * from "./MenuSideBarSection.vue?vue&type=script&lang=ts"
import style0 from "./MenuSideBarSection.vue?vue&type=style&index=0&id=37180f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37180f1a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseText: require('/home/runner/work/jafolders-web-customer/jafolders-web-customer/components/atoms/BaseText.vue').default,SideBarItem: require('/home/runner/work/jafolders-web-customer/jafolders-web-customer/components/molecules/SideBarItem.vue').default})
